// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ManageWorkspaceDrawerRelatedCampaignsQueryVariables = PrivateSchemaTypes.Exact<{
  workspaceId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ManageWorkspaceDrawerRelatedCampaignsQuery = (
  { __typename?: 'Query' }
  & { workspace?: PrivateSchemaTypes.Maybe<{ __typename?: 'WorkspaceModelAsCollaborator' } | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & { relatedCampaigns: Array<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id' | 'name'>
      & { author?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserModel' }
        & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name' | 'account_name' | 'email'>
      )> }
    )>, indirectRelatedCampaigns?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'IndirectWorkspaceRelatedCampaigns' }
      & { filterRelatedCampaigns: Array<(
        { __typename?: 'CampaignModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name'>
        & { author?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserModel' }
          & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
        )> }
      )>, actionRelatedCampaigns: Array<(
        { __typename?: 'CampaignModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name'>
        & { author?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserModel' }
          & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
        )> }
      )> }
    )> }
  ) | { __typename?: 'WorkspaceModelAsMember' }> }
);


export const ManageWorkspaceDrawerRelatedCampaignsDocument = gql`
    query ManageWorkspaceDrawerRelatedCampaigns($workspaceId: PositiveInt!) {
  workspace(id: $workspaceId) {
    ... on WorkspaceModelAsCoordinator {
      relatedCampaigns {
        id
        name
        author {
          id
          display_name
          account_name
          email
        }
      }
      indirectRelatedCampaigns {
        filterRelatedCampaigns {
          id
          name
          author {
            id
            userIdentity
          }
        }
        actionRelatedCampaigns {
          id
          name
          author {
            id
            userIdentity
          }
        }
      }
    }
  }
}
    `;

/**
 * __useManageWorkspaceDrawerRelatedCampaignsQuery__
 *
 * To run a query within a React component, call `useManageWorkspaceDrawerRelatedCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageWorkspaceDrawerRelatedCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageWorkspaceDrawerRelatedCampaignsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useManageWorkspaceDrawerRelatedCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ManageWorkspaceDrawerRelatedCampaignsQuery, ManageWorkspaceDrawerRelatedCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManageWorkspaceDrawerRelatedCampaignsQuery, ManageWorkspaceDrawerRelatedCampaignsQueryVariables>(ManageWorkspaceDrawerRelatedCampaignsDocument, options);
      }
export function useManageWorkspaceDrawerRelatedCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManageWorkspaceDrawerRelatedCampaignsQuery, ManageWorkspaceDrawerRelatedCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManageWorkspaceDrawerRelatedCampaignsQuery, ManageWorkspaceDrawerRelatedCampaignsQueryVariables>(ManageWorkspaceDrawerRelatedCampaignsDocument, options);
        }
export type ManageWorkspaceDrawerRelatedCampaignsQueryHookResult = ReturnType<typeof useManageWorkspaceDrawerRelatedCampaignsQuery>;
export type ManageWorkspaceDrawerRelatedCampaignsLazyQueryHookResult = ReturnType<typeof useManageWorkspaceDrawerRelatedCampaignsLazyQuery>;
export type ManageWorkspaceDrawerRelatedCampaignsQueryResult = Apollo.QueryResult<ManageWorkspaceDrawerRelatedCampaignsQuery, ManageWorkspaceDrawerRelatedCampaignsQueryVariables>;